import { useMemo } from 'react';

import { routes } from '@aline/routes';
import { useMatch } from 'react-router-dom';
import type { Apollo } from 'src/gql/generated';

/**
 * The workflow, task or skill page the user is looking at, sent with each prompt so
 * the agent acts on it. A task page sends only its task: the server resolves
 * the parent workflow from it and accepts one of them, not several.
 */
export function useVisiblePageContext(): Apollo.AgentVisibleContextInput | undefined {
  const workflowPageMatch = useMatch({ end: false, path: routes.WorkflowDetail });
  const taskPageMatch = useMatch({ end: false, path: routes.WorkflowDetailTabTask });
  const skillPageMatch = useMatch({ end: false, path: routes.AdminAgentSkillDetail });
  const taskId = taskPageMatch?.params.taskId;
  const workflowId = workflowPageMatch?.params.workflowId;
  const skillId = skillPageMatch?.params.skillId;

  return useMemo(() => {
    if (taskId) return { taskId };
    if (workflowId) return { workflowId };
    if (skillId) return { skillId };
    return undefined;
  }, [skillId, taskId, workflowId]);
}
